import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "6948 1125 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m6964.6 1143-6.3-6.3q-.75.6-1.725.95t-2.075.35q-2.725 0-4.612-1.887-1.889-1.888-1.888-4.613 0-2.725 1.888-4.613 1.887-1.887 4.612-1.887t4.612 1.887q1.889 1.888 1.888 4.613a6.1 6.1 0 0 1-1.3 3.8l6.3 6.3zm-10.1-7q1.875 0 3.188-1.312 1.311-1.313 1.312-3.188 0-1.875-1.312-3.187-1.314-1.313-3.188-1.313t-3.187 1.313-1.313 3.187q0 1.875 1.313 3.188 1.311 1.312 3.187 1.312",
      class: "fills",
      style: {"fill":"#000","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }